import { render } from "./V3Warning.vue?vue&type=template&id=7cc284c6&scoped=true"
import script from "./V3Warning.vue?vue&type=script&lang=js"
export * from "./V3Warning.vue?vue&type=script&lang=js"

import "./V3Warning.vue?vue&type=style&index=0&id=7cc284c6&scoped=true&lang=scss"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cc284c6"]])

export default __exports__